import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";
import Link from "next/link";
import { __ } from "@/lib/i18n/functions";
import { Locales } from "@/lib/i18n";

type CategoryProps = {
  imageSRC?: string;
  imageALT: string;
  text: string;
  textPosition?: "left" | "center" | "right";
  link: string;
  locale: Locales;
  priority?: boolean;
};

const Category = ({
  link,
  imageSRC,
  imageALT,
  text,
  textPosition = "left",
  locale,
  priority = false,
}: CategoryProps) => {
  return (
    <figure className={cn("group relative w-full max-w-[31.625rem] mx-auto")}>
      <div className="relative flex w-full flex-col gap-2">
        <div className="relative flex aspect-video h-full max-h-[21.063rem] w-full items-center justify-center overflow-hidden rounded-lg bg-gray-100">
          {imageSRC ? (
            <Image
              alt={imageALT}
              src={imageSRC}
              fill
              sizes="(min-width: 1280px) 25vw, (min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
              className="absolute object-cover transition-transform duration-300 group-hover:scale-105"
              priority={priority}
            />
          ) : (
            <span className="text-sm text-gray-500">{__("No Image Available",locale)}</span>
          )}
        </div>

        {text && (
          <figcaption
            className={cn("group-hover:text-primary text-lg font-normal transition-colors duration-300", {
              "text-left": textPosition === "left",
              "text-center": textPosition === "center",
              "text-right": textPosition === "right",
            })}
          >
            {text}
          </figcaption>
        )}
      </div>

      <Link className="absolute inset-0" href={link || "#"}>
        <span className="sr-only">
          {__("View", locale)} {imageALT}
        </span>
      </Link>
    </figure>
  );
};

export default Category;
